var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "81px",
    height: "27px",
    viewBox: "0 0 81 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "visa") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Figurehead",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card-schemes",
    transform: "translate(-87.000000, -72.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "visa",
    transform: "translate(75.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-26",
    fillOpacity: 0,
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 110,
    height: 70
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.000000, 21.000000)",
    id: "g4155-Clipped",
    fillRule: "nonzero",
    fill: "#1A1F71"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.000000, 14.345679) scale(1, -1) translate(-41.000000, -14.345679) translate(0.000000, 0.345679)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4155"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4161",
    transform: "translate(0.054676, 0.096245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9238261,26.5122639 L34.5652696,0.772857503 L28.0839773,0.772857503 L33.4430206,26.5122639 L39.9238261,26.5122639 L39.9238261,26.5122639 Z M67.1908255,9.89157558 L70.602852,19.558047 L72.5654489,9.89157558 L67.1908255,9.89157558 L67.1908255,9.89157558 Z M74.4253149,0.772857503 L80.4182707,0.772857503 L75.182407,26.5122639 L69.6539308,26.5122639 C68.4080154,26.5122639 67.3583109,25.7699205 66.8933443,24.6253911 L57.1679977,0.772857503 L63.9745232,0.772857503 L65.3260907,4.61663553 L73.6399841,4.61663553 L74.4253149,0.772857503 L74.4253149,0.772857503 Z M57.5054027,9.17624469 C57.5341284,15.9688868 48.3662547,16.345561 48.4271142,19.3804649 C48.4470761,20.3028916 49.3030039,21.285346 51.1750419,21.5364622 C52.1035143,21.6595191 54.6639948,21.7585649 57.5672359,20.3844293 L58.7026306,25.8449552 C57.143167,26.4242231 55.1367513,26.9824814 52.6405384,26.9824814 C46.2332512,26.9824814 41.7257539,23.4858639 41.6897251,18.4745458 C41.6488275,14.7688317 44.9094356,12.702876 47.3608559,11.4688052 C49.8887157,10.2072216 50.7358798,9.3978472 50.7237079,8.27082587 C50.7061804,6.54402709 48.7075547,5.77967352 46.8476886,5.7506601 C43.5865937,5.69863604 41.6975151,6.65607893 40.191121,7.3774126 L39.0148287,1.73480247 C40.5314472,1.02147251 43.3261151,0.400685346 46.2201056,0.368670537 C53.0314998,0.368670537 57.4854408,3.82476924 57.5054027,9.17624469 L57.5054027,9.17624469 Z M30.6629591,26.5122639 L20.1615322,0.772857503 L13.3111879,0.772857503 L8.14299989,21.3148597 C7.82993867,22.577944 7.55680127,23.0421587 6.60398508,23.5759056 C5.04549524,24.445808 2.47235596,25.2591842 0.210330401,25.7654184 L0.363209442,26.5122639 L11.391923,26.5122639 C12.79656,26.5122639 14.0604899,25.5518196 14.381828,23.8895507 L17.1117414,8.99366023 L23.8539992,26.5122639 L30.6629591,26.5122639 L30.6629591,26.5122639 Z",
    id: "path4163"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.3c45a43fb452656bd6abf1f6c4cc2b32.svg";
export { ForwardRef as ReactComponent };